/*
 * Copyright (c) 2020. Sonrai Analytics Ltd.
 * Developed by Warren Dowey
 */

import { Injectable } from '@angular/core';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { HttpClient } from '@angular/common/http';
import { ProjectDataModel } from '@app/models/project-data.model';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
@Injectable({
  providedIn: 'root',
})
export class ProjectDataListService extends ApiBaseService {
  private _projectDataList: ProjectDataModel[] = [];
  protected _endpoint = 'project_data';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get projectDataList(): ProjectDataModel[] {
    return this._projectDataList;
  }

  set projectDataList(value: ProjectDataModel[]) {
    this._projectDataList = value;
  }

  /**
   *  Warren Dowey
   *
   *  getProjectDataByProjectId
   *
   * : Get a list of projectData based on the projectSlug
   *
   * @param projectId of type string
   *
   * @returns Void: gets the projectData array with the projectId that meets the query
   */
  getProjectDataByProjectId(projectId: string): ProjectDataModel[] {
    let tempList: ProjectDataModel[] = [];
    for (const data of this.projectDataList) {
      if (data.projectId === projectId) {
        tempList.push(data);
      }
    }
    return tempList;
  }

  /**
   *  Ryan Duffy
   *
   *  getProjectDataByProjectIdgetProjectDataByProjectIdAndIsActive
   *
   * : Get a list of projectData based on the projectId  & isActive
   *
   * @param projectId of type string
   * @param isActive of boolean
   *
   * @returns Void: gets the projectData array with the projectId that meets the query
   */
  getProjectDataByProjectIdAndIsActive(projectId: string, isActive: boolean): ProjectDataModel[] {
    let tempList: ProjectDataModel[] = [];
    for (const data of this.projectDataList) {
      if (data.projectId === projectId && data.isActive === isActive) {
        tempList.push(data);
      }
    }
    return tempList;
  }

  /**
   *  Warren Dowey
   *
   *  getProjectDataById
   *
   * : Get a projectData based on the projectDataId by checking the list
   *
   * @param projectDataId of type string
   *
   * @returns ProjectDataModel
   */
  getProjectDataById(projectId: string): ProjectDataModel[] {
    const projectDataList = [];
    if (!this.projectDataList) {
      return;
    }
    for (const data of this.projectDataList) {
      if (data.projectId === projectId) {
        projectDataList.push(data);
      }
    }
    return projectDataList;
  }

  /**
   *   Warren Dowey
   *
   *  addtoList
   *
   * : handles the insert of a new projectData into the list
   *
   * @param data of type ProjectDataModel
   *
   * @returns Void: inserts a new projectData into the list
   */
  addToList(data: ProjectDataModel): void {
    this.projectDataList.push(data);
  }
  /**
   *   Warren Dowey
   *
   *  removeFromList
   *
   * : deletes a projectData from the list
   *
   * @param data of type ProjectDataModel
   *
   * @returns Void: deletes a projectData
   */
  removeFromList(data: ProjectDataModel): void {
    let x = 0;
    if (data && this.projectDataList.length > 0) {
      for (const data of this.projectDataList) {
        if (data.projectDataId === data.projectDataId) {
          this.projectDataList.slice(x, 1);
        }
        x++;
      }
    }
  }
  /**
   *  Warren Dowey
   *
   *  updateInList
   *
   * : handles the update of a projectData in the list
   *
   * @param data of type ProjectDataModel
   *
   * @returns Void: update the list with the data
   */
  updateInList(data: ProjectDataModel): void {
    this.projectDataList.forEach((projectData, index) => {
      if (data.projectDataId === projectData.projectDataId) {
        this.projectDataList.splice(index, 1);
        this.projectDataList.push(data);
      }
    });
  }

  /**
   *  Ryan Duffy
   *
   *  updateInListByProjectIdAndActive
   *
   * : handles the update of a projectData in the list
   *
   * @param data of type ProjectDataModel
   *
   * @returns Void: update the list with the data
   */
  updateInListByProjectIdAndActive(data: ProjectDataModel): void {
    this.projectDataList.forEach((projectData, index) => {
      if (data.projectId === projectData.projectId && projectData.isActive) {
        this.projectDataList.splice(index, 1);
        this.projectDataList.push(data);
      }
    });
  }
  /**
   *  Warren Dowey
   *
   *  handleData
   *
   * : handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type ProjectImageModel[]
   *
   * @returns Void
   */
  protected handleData(data: any): void {
    let projectData: ProjectDataModel;
    this.projectDataList = [];
    for (const item of data) {
      projectData = new ProjectDataModel();
      this.addToList(projectData.fromJson(item));
    }
    super.handleData(this.projectDataList);
  }
}
